/**
 * 事件相关接口
 */
import request from '../utils/axios'

/**
 * 添加事件接口
 * @param {*} data
 * {
 *  "type": "string",
 *  "imgIds": "string",
 *  "videoIds": "string",
 *  "report": "string",
 *  "phone": "string",
 *  "description": "string",
 *  "geo": "string"
 * }
 * @returns
 */
export function addEventApi(data) {
  return request({
    url: "/Event/Add",
    method: 'POST',
    data
  })
}

/**
 * 修改事件接口
 * @param {*} data
 * {
 *  "type": "string",
 *  "imgIds": "string",
 *  "videoIds": "string",
 *  "report": "string",
 *  "phone": "string",
 *  "description": "string",
 *  "geo": "string",
 *  "id": 0
 * }
 * @returns
 */
export function updateEventApi(data) {
  return request({
    url: "/Event/Update",
    method: 'POST',
    data
  })
}

/**
 * 审核事件接口
 * @param {*} data
 * {
 *  "id": 12,
 *  "isPass": true,
 *  "explain": "string"
 * }
 * @returns
 */
export function examineEventApi(data) {
  return request({
    url: "/Event/Examine",
    method: 'POST',
    data
  })
}

/**
 * 处理事件接口
 * @param {*} data
 * {
 *  "id": 12,
 *  "result": "string"
 * }
 * @returns
 */
export function handleEventApi(data) {
  return request({
    url: "/Event/Handle",
    method: 'POST',
    data
  })
}

/**
 * 通过id删除事件(工作人员)
 * @param {*} id
 * @returns
 */
export function DeleteEvent(id) {
    return request({
      url: `/Event/DeleteEvent?id=${id}`,
      method: "GET",
    })
  }

/**
 * 通过ids批量删除事件(工作人员)
 * @param {*} data
 * {
 *  "id": 12,
 *  "result": "string"
 * }
 * @returns
 */
export function deleteEventByIds(data) {
  return request({
    url: "/Event/DeleteEventByIds",
    method: 'POST',
    data
  })
}

/**
 * 通过id删除事件
 * @param {*} id
 * @returns
 */
export function deleteEventById(id) {
  return request({
    url: `/Event/Delete?id=${id}`,
    method: "GET",
  })
}

/**
 * 通过id获取事件详情
 * @param {*} id
 * @returns
 */
export function getEventDetailById(id) {
  return request({
    url: `/Event/GetDetails?id=${id}`,
    method: "GET",
  })
}

/**
 * 获取指派给下拉框(工作人员)
 * @param {*} id
 * @returns
 */
export function GetDesigneeBox(id) {
  return request({
    url: `/Event/GetDesigneeBox?id=${id}`,
    method: "GET",
  })
}

/**
 * 获取事件操作记录(工作人员)
 * @param {*} id
 * @returns
 */
export function GetEventHistory(id) {
  return request({
    url: `/Event/GetEventHistory?id=${id}`,
    method: "GET",
  })
}

/**
 * 获取当前用户的事件详情
 * @param {*} data
 * {
 *  "pageNumber": 1,
 *  "pageSize": 10
 * }
 * @returns
 */
export function getMyEventList(data) {
  return request({
    url: "/Event/GetList",
    method: "POST",
    data
  })
}


/**
 * 获取最近事件(工作人员)
 * @returns
 */
export function GetLatelyEvents() {
  return request({
    url: '/Event/GetLatelyEvents',
    method: "GET",
  })
}


/**
 * 获取事件列表图形(工作人员)
 * @returns
 */
export function GetAllEventGoe(data) {
  return request({
    url: '/Event/GetAllEventGoe',
    method: "POST",
    data
  })
}


/**
 * 获取事件类型统计(工作人员)
 */
export function GetEventCount() {
  return request({
    url: '/Event/GetEventCount',
    method: "GET",
  })
}

/**
 * 获取事件列表（工作人员）
 * @returns
 */
export function GetEventLis(data) {
  return request({
    url: '/Event/GetEventLis',
    method: "POST",
    data
  })
}

/**
 * 获取事件详情(工作人员)
 * @param {*} id
 * @returns
 */
export function GetEventDetails(id) {
  return request({
    url: `/Event/GetEventDetails?id=${id}`,
    method: "GET",
  })
}

/**
 * 事件处理（工作人员）
 * @returns
 */
export function SetEvents(data) {
  return request({
    url: '/Event/SetEvent',
    method: "POST",
    data
  })
}

/**
 * 添加事件协作人（工作人员）
 * @returns
 */
export function AddEventStaff(data) {
  return request({
    url: '/Event/AddEventStaff',
    method: "POST",
    data
  })
}

/**
 * 获取事件列表图层（工作人员）
 * @returns
 */
export function GetEventLisGeo(data) {
  return request({
    url: '/Event/GetEventLisGeo',
    method: "POST",
    data
  })
}

/**
 * 获取事件列表图层（工作人员）
 * @returns
 */
export function GetLhzfCount() {
  return request({
    url: '/Event/GetLhzfCount',
    method: "get"
  })
}